import React from 'react';

const NextPrev = ({ children }) => {
  return <nav data-token-nextprev>{children}</nav>;
};

export default NextPrev;
